import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTargetItemDimensionIndicatorSelect.translations.json';
import { FormField, FormSelect } from '../../../common/form';
import { AlgorithmTargetMappingTargetOption } from './ruleOptions/types';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-target-modal',
);
addTranslations(translations);

export interface AlgorithmTargetItemDimensionIndicatorSelectProps {
  index: number;
  options: AlgorithmTargetMappingTargetOption[];
}

const filterOption = (
  input: string,
  option?: AlgorithmTargetMappingTargetOption,
) =>
  (option?.codeName?.toString() ?? '')
    .toLowerCase()
    .includes(input.toLowerCase());

export function AlgorithmTargetItemDimensionIndicatorSelect({
  index,
  options,
}: AlgorithmTargetItemDimensionIndicatorSelectProps) {
  const { t } = useTranslation();
  const name = `rules.${index}.dimensionIndicators` as const;

  return (
    <FormField
      required
      size="large"
      label={t('dimensionIndicator.label')}
      name={name}
      style={{ minWidth: 0 }}
    >
      <FormSelect
        name={name}
        allowClear
        options={options}
        showSearch
        filterOption={filterOption}
        mode="multiple"
        className="nodrag nopan"
      />
    </FormField>
  );
}
